<template>
  <div>
    <div class="mobile">
      <span v-if="arr[eye]">{{ arr[keyName+1] }}</span>
      <span v-else>{{ arr[keyName] }}</span>
      <span v-if="arr[keyName]">
        <i class="iconfont iconxianshi eye-icon eye" v-if="arr[eye]" @click="openEye(arr)"></i>
        <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(arr)"></i>
      </span>
    </div>
  </div>
</template>

<script>
import { common } from "@/api/mixins";
export default {
  mixins: [common],
  props: ["arr","eye","keyName"],
  data() {
    return {

    }
  },
  methods: {
    openEye(arr) {
      let operationType
      if(this.keyName == 'idNo'){
        operationType = 1
      }else if(this.keyName == 'mobile'){
        operationType = 2
      }else if(this.keyName == 'email'){
        operationType = 4
      }else if(this.keyName == 'cardNo'){
        operationType = 3
      }
      if (!arr[this.eye]) {
        this.descrypt(
          {
            query: arr.orderNo || arr.id,
            operationFunction: 23,
            operationType: operationType,
          },
          arr,
          this.keyName+'1',
        ).then(() => {
          this.$set(arr, this.eye, true);
        });
      } else {
        this.$set(arr, this.eye, false);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.mobile{
  display: flex;
}
</style>